const FA_DIGITS = '۰۱۲۳۴۵۶۷۸۹';

export const toEnglishDigits = value => String(value ?? '')
  .replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
  .replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
  .replace(/[،,٬\s]/g, '')
  .trim();

export const toPersianDigits = value => String(value ?? '')
  .replace(/[0-9]/g, digit => FA_DIGITS[Number(digit)])
  .replace(/[٠-٩]/g, digit => FA_DIGITS['٠١٢٣٤٥٦٧٨٩'.indexOf(digit)]);

export const groupThousands = digits => digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const currentGregorianYear = () => new Date().getFullYear();
export const currentJalaliYear = () => currentGregorianYear() - 621;
export const jalaliToGregorianYear = year => Number(year) + 621;
export const gregorianToJalaliYear = year => Number(year) - 621;

export const buildYearOptions = calendar => {
  const max = calendar === 'jalali' ? currentJalaliYear() : currentGregorianYear();
  const min = calendar === 'jalali' ? 1300 : 1921;
  return Array.from({ length: max - min + 1 }, (_, index) => max - index);
};

export const PRESET_COLORS = [
  { value: 'سفید', hex: '#ffffff' }, { value: 'مشکی', hex: '#15181d' },
  { value: 'نقره‌ای', hex: '#b9c0ca' }, { value: 'خاکستری', hex: '#777f8b' },
  { value: 'قرمز', hex: '#d83b3b' }, { value: 'آبی', hex: '#2879d8' },
  { value: 'سرمه‌ای', hex: '#172b4c' }, { value: 'سبز', hex: '#238553' },
  { value: 'زرد', hex: '#efc735' }, { value: 'نارنجی', hex: '#ed8126' },
  { value: 'قهوه‌ای', hex: '#74513b' }, { value: 'سایر', hex: 'linear-gradient(135deg,#d83b3b 25%,#efc735 25% 50%,#238553 50% 75%,#2879d8 75%)' },
];

export const EMPTY_VEHICLE_FORM = {
  carModel: '', productionYearJalali: '', productionYearGregorian: '',
  carColor: '', currentMileage: '', plate: '',
};

export const parsePlateString = plateString => {
  if (!plateString) return { plate1: '', plate2: '', plate3: '', plateEnd: '' };
  const match = String(plateString).trim().match(/^([\d\u06F0-\u06F9\u0660-\u0669\s]+)\s*([^\d\u06F0-\u06F9\u0660-\u0669\s|])\s*([\d\u06F0-\u06F9\u0660-\u0669\s]+)\s*\|\s*([\d\u06F0-\u06F9\u0660-\u0669]+)$/);
  if (!match) return { plate1: '', plate2: '', plate3: '', plateEnd: '' };
  return { plate1: match[1].trim(), plate2: match[3].trim(), plate3: match[2].trim(), plateEnd: match[4].trim() };
};

const isPlateEmpty = plateString => {
  if (!plateString) return true;
  const parsed = parsePlateString(plateString);
  if (parsed.plate1 || parsed.plate2 || parsed.plate3 || parsed.plateEnd) return false;
  return String(plateString).replace(/\|/g, '').trim() === '';
};

const isPlateComplete = plateString => {
  const { plate1, plate2, plate3, plateEnd } = parsePlateString(plateString);
  return toEnglishDigits(plate1).length === 2 && plate3.trim().length === 1 && toEnglishDigits(plate2).length === 3 && toEnglishDigits(plateEnd).length === 2;
};

export function validateVehicleForm(form) {
  const errors = {};
  if (!form.carModel.trim()) errors.carModel = 'مدل خودرو را وارد کنید';

  const jalali = toEnglishDigits(form.productionYearJalali);
  const gregorian = toEnglishDigits(form.productionYearGregorian);
  if (!jalali && !gregorian) {
    errors.productionYearJalali = 'سال ساخت را انتخاب کنید';
    errors.productionYearGregorian = 'سال ساخت را انتخاب کنید';
  } else {
    if (!/^\d{4}$/.test(jalali) || Number(jalali) < 1300 || Number(jalali) > currentJalaliYear()) errors.productionYearJalali = 'سال شمسی معتبر نیست';
    if (!/^\d{4}$/.test(gregorian) || Number(gregorian) < 1921 || Number(gregorian) > currentGregorianYear()) errors.productionYearGregorian = 'سال میلادی معتبر نیست';
  }

  const mileage = toEnglishDigits(form.currentMileage);
  if (mileage && !/^\d+$/.test(mileage)) errors.currentMileage = 'کیلومتر باید عدد باشد';
  if (!isPlateEmpty(form.plate) && !isPlateComplete(form.plate)) errors.plate = 'پلاک را کامل وارد کنید';
  return errors;
}
